/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAccessStatusesHttpResponse,
  ApiAccountPasswordDto,
  ApiAccountSessionSubscriptionResponse,
  ApiEmailCodeDto,
  ApiUpdateAccountSchemaVersionDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Account<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Account
   * @name AccountControllerMe
   * @summary Get account by request context
   * @request GET:/account/me
   * @secure
   * @response `200` `ApiAccountSessionSubscriptionResponse`
   */
  accountControllerMe = (params: RequestParams = {}) =>
    this.request<ApiAccountSessionSubscriptionResponse, ApiBaseError>({
      path: `/account/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Account
   * @name AccountControllerGetAccessStatuses
   * @summary Get access statuses
   * @request GET:/account/access-statuses
   * @secure
   * @response `200` `ApiAccessStatusesHttpResponse`
   */
  accountControllerGetAccessStatuses = (
    query: {
      /* Template custom: data-contract-jsdoc */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAccessStatusesHttpResponse, ApiBaseError>({
      path: `/account/access-statuses`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Account
   * @name AccountControllerBlockAccount
   * @summary Blocking account
   * @request POST:/account/block
   * @secure
   * @response `200` `boolean`
   * @response `400` `void`
   */
  accountControllerBlockAccount = (
    data: ApiEmailCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/account/block`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Account
   * @name AccountControllerVerifyPassword
   * @summary Verify password
   * @request POST:/account/verify-password
   * @secure
   * @response `200` `boolean`
   */
  accountControllerVerifyPassword = (
    data: ApiAccountPasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/account/verify-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Updates the schema version for the authenticated account
   *
   * @tags Account
   * @name AccountControllerUpdateAccountSchemaVersion
   * @summary Update account schema version
   * @request POST:/account/update-schema-version
   * @secure
   * @response `200` `ApiAccountSessionSubscriptionResponse` Returns the updated account with the new schema version
   * @response `400` `void` Invalid schema version provided
   */
  accountControllerUpdateAccountSchemaVersion = (
    data: ApiUpdateAccountSchemaVersionDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountSessionSubscriptionResponse, ApiBaseError>({
      path: `/account/update-schema-version`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
